/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { ReportData } from '@g17eco/types/reportData';
import { VisibilityStatus } from '@g17eco/types/download';
import { formatCalculationNumber } from '@utils/formula';
import { getUtrvData } from '@features/report-output/common';

export const getHealthTable = (questionData: ReportData[], visibility: VisibilityStatus) => {
  return [
    {
      header: 'Fatalities',
      code: 'gri/2020/403-9/a',
      valueListCode: 'injuries_company_employees_number_fatalities',
      unit: '',
    },
    {
      header: 'High consequence injuries',
      code: 'gri/2020/403-9/a',
      valueListCode: 'injuries_company_employees_high-consequence_work-related_injuries_number',
      unit: '',
    },
    {
      header: 'Injuries',
      code: 'gri/2020/403-9/a',
      valueListCode: 'injuries_company_employees_recordable_injuries_number',
      unit: '',
    },
    {
      header: 'Work-related Ill Health',
      code: 'gri/2020/403-10/a',
      valueListCode: 'health_ill_health',
      unit: 'cases',
    },
  ].map((data) => {
    const utrvData = getUtrvData({
      visibility,
      reportData: questionData,
      utrCode: data.code,
      tableColumn: data.valueListCode,
    });
    return [data.header, data.unit, formatCalculationNumber(utrvData.value ?? '')];
  });
};
